import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import authService from '../services/authService';
import './Login.css';
import Swal from 'sweetalert2';
import logsUserService from '../services/logsUserServices';
import Header from './Header';

const Qr = () => {
  return (

    <div className="external-container d-flex justify-content-center align-items-center vh-100">
      <header className="header">
        <nav className="navbar navbar-expand-md fixed-top navbar-light bg-transparent">
          <div className="container-fluid d-flex justify-content-end align-items-center">
            {/* <a className="navbar-brand order-3">
              <img src="./aviancaLogo.png" className="mx-3 img-fluid" alt="logo" />
            </a> */}
          </div>
        </nav>
      </header>

      <div className="container d-flex justify-content-center align-items-center flex-column mt-5">
        <div className="col-12 m-0 p-0 m-t-0 mb-3">
          <div className="col-12 d-flex justify-content-center align-items-center">
            <div className="d-flex justify-content-center align-items-center flex-column">
              <div className="col-12 col-lg-6 mx-3 d-flex justify-content-center align-items-center">
                <img src="./aviancaLogo.png" className="container-other-logo-events" alt="avianca" />
              </div>
              <div className="col-12 col-lg-5 d-flex justify-content-center align-items-center flex-column">
                <div className="col-12 col-lg-8 d-flex justify-content-center align-items-center">
                  <img src="./Codigo-QR.png" className="container-logo-events mb-5" alt="avianca" />
                </div>
                <h1 className="title-login-sesion Bebas-Neue">Escanea aquí</h1>
                <h3 className="title-login-sesion Bebas-Neue">
                  y participa por
                  grandes premios
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* footer mobile */}
      <footer className="d-block d-md-none d-lg-none d-xl-none col-12 mt-auto">
        <div className="d-flex justify-content-between align-items-center text-white mb-2">
          <div className='mx-4 mb-3'>
            <img src="./Logo-SuperTransporte.png" style={{ width: '100%' }} alt="logo" />
          </div>
          <div className='text-end mx-4 mb-3'>
            <img src="./Logo-Footer-2.png" style={{ width: '70%' }} alt="logo" />
          </div>
        </div>
      </footer>

      <footer className="d-none d-md-block d-lg-block d-xl-block col-12 mt-auto col-12 mt-auto bg-transparent">
        <div className="d-flex justify-content-between align-items-center text-white mb-2">
          <div className='mx-4 mb-3'>
            <img src="./Logo-SuperTransporte.png" style={{ width: '85%' }} alt="logo" />
          </div>
          <div className='text-end mx-4 mb-3'>
            <img src="./Logo-Footer-2.png" style={{ width: '35%' }} alt="logo" />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Qr;
